import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DestructiveConfirmModalData {
  readonly title: string;
  readonly description: string;
  readonly storeName: string;
  readonly lotsToDelete: number;
  readonly unitsToDelete: number;
  readonly confirmWord: string;
}

@Component({
  selector: 'app-destructive-confirm-modal',
  templateUrl: './destructive-confirm-modal.component.html',
  styleUrls: ['./destructive-confirm-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DestructiveConfirmModalComponent {
  readonly form: FormGroup;

  constructor(
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<DestructiveConfirmModalComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public readonly data: DestructiveConfirmModalData,
  ) {
    this.form = this.fb.group({
      typed: ['', [Validators.required, this.exactMatchValidator(data.confirmWord)]],
    });
  }

  get canConfirm(): boolean {
    return this.form.valid;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    if (!this.canConfirm) return;
    this.dialogRef.close(true);
  }

  private exactMatchValidator(expected: string) {
    const normalizedExpected = expected.trim();
    return (control: { value: unknown }) => {
      const value = typeof control.value === 'string' ? control.value.trim() : '';
      return value === normalizedExpected ? null : { mismatch: true };
    };
  }
}
